import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { API } from "../config/api-config";
import { HttpService } from "../service/http-service";

declare var alertify: any;
@Component({
  selector: "app-member-document",
  templateUrl: "./member-document.component.html",
  styleUrls: ["./member-document.component.css"],
})
export class MemberDocumentComponent implements OnInit {
  constructor(private http: HttpService, private router: Router) {}

  public list: Array<any> = [];
  public imagePath: any;
  public pageData: object = {};
  public page = { pageNumber: 1 };
  public searchValue: any = {
    memberId: "",
    active: "",
  };

  ngOnInit() {
    this.getList();
  }

  public edit(id) {
    this.router.navigate(["/index/experienceparams", id]);
  }

  public getList(isSearch = false) {
    let data = { ...this.page };
    data.pageNumber--;

    if (isSearch) {
      data = { ...data, ...this.searchValue };
    }
    this.http.getData(API.memberDocument, data).then((res) => {
      this.list = res.data.content;
      this.pageData = res.data;
      delete this.pageData["content"];
    });
  }

  public pageChange(e: any) {
    this.page = e;
    this.getList();
  }
  resend(id) {
    this.http.postData(API.memberDocumentResend + "/" + id, {}).then((res) => {
      alertify.success(res.status.message);
      this.getList(true);
    });
  }

  public searchData() {
    this.page.pageNumber = 1;
    this.getList(true);
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/member-document/member-document.component.ts